import { LEAD_STAGE_CURRENT, NODE_DATA_LEAD_STAGE_KEY, type GraphChangeSetWrite, type GraphNode } from "@salesko/contracts";
import { stableEditHash } from "./nodeEdit";

/**
 * Toggles a node's Current-lane membership (data.leadStage). Mirrors
 * nodeEditChangeSetWrite's shape: a single upsert_node command that preserves
 * every existing node field and only touches the one data key this action
 * owns — upsert_node fully replaces a node by id (apps/api/src/graph-storage.ts's
 * applyGraphOperation), so any other field would otherwise be silently dropped.
 */
export function leadStageToggleChangeSetWrite(node: GraphNode, target: "current" | null): GraphChangeSetWrite {
  const nextData: GraphNode["data"] = { ...node.data };
  if (target === "current") {
    nextData[NODE_DATA_LEAD_STAGE_KEY] = LEAD_STAGE_CURRENT;
  } else {
    delete nextData[NODE_DATA_LEAD_STAGE_KEY];
  }

  const nextNode: GraphNode = { ...node, data: nextData };
  const reason = target === "current" ? `Move to Current: ${node.label}` : `Remove from Current: ${node.label}`;

  return {
    reason: reason.slice(0, 500),
    clientMutationId: `lead-stage:${node.id}:${stableEditHash(`${node.id}\n${target ?? "clear"}`)}`.slice(0, 128),
    commands: [
      {
        type: "upsert_node",
        node: nextNode
      }
    ]
  };
}
